module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFAgMAAAABCpX7AAAAAXNSR0IB2cksfwAAAAxQTFRFAAAAAAAAAAAAAAAANek3lgAAAAR0Uk5TAGD/oL628yAAAAAcSURBVHicY8hatYFBatUBBrbVDAyMaxgYGAoYAEAHBRdQLz12AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/select-arrow.png
// module id = 905
// module chunks = 0